"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorPickerTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
const colorPickerTheme = (0, _sdsThemeInternal.themed)({
  colorSelector: {
    borderRadius: {
      "lodestar-light": "4px",
      "ursa-light": "8px"
    },
    width: {
      "lodestar-light": "248px",
      "ursa-light": "320px"
    },
    backgroundColor: (0, _designTokensReact.color)("color--background--surfaces--body"),
    boxShadow: {
      "lodestar-light": "0px 2px 12px rgba(0, 0, 0, 0.16)",
      // no semantic token
      "ursa-light": (0, _designTokensReact.color)("elevation--default")
    },
    padding: {
      "lodestar-light": "12px",
      "ursa-light": "16px"
    },
    buttonWrap: {
      marginBottom: {
        "lodestar-light": "16px",
        "ursa-light": "12px"
      }
    },
    customSection: {
      marginTop: {
        "lodestar-light": "16px",
        "ursa-light": "12px"
      },
      marginBottom: {
        "lodestar-light": "16px",
        "ursa-light": "8px"
      },
      variant: {
        "lodestar-light": "bodyText",
        "ursa-light": "Inter--12px--400w"
      }
    },
    addButton: {
      backgroundColor: {
        rest: {
          "lodestar-light": _designTokens.lodestarColors.buttonDefault,
          "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weaker")
        },
        hover: (0, _designTokensReact.color)("color--background--neutral--default"),
        active: (0, _designTokensReact.color)("color--background--neutral--strong"),
        disabled: {
          "lodestar-light": _designTokens.lodestarColors.buttonDefault,
          "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weaker")
        }
      },
      color: {
        rest: (0, _designTokensReact.color)("color--icons--spectrum-neutral--default"),
        disabled: (0, _designTokensReact.color)("color--text--neutral--weaker")
      },
      order: {
        "lodestar-light": 1,
        "ursa-light": 0
      }
    }
  },
  colorButton: {
    size: {
      "lodestar-light": "20px",
      "ursa-light": "32px"
    },
    borderRadius: {
      "lodestar-light": "50%",
      "ursa-light": "6px"
    },
    borderColor: {
      "lodestar-light": "rgba(17, 17, 17, 0.1)",
      // no semantic token
      "ursa-light": (0, _designTokensReact.color)("color--border--neutral--weakest")
    },
    margin: {
      "lodestar-light": "4px",
      "ursa-light": "2px"
    },
    before: {
      size: {
        "lodestar-light": "28px",
        "ursa-light": "38px"
      },
      borderRadius: {
        "lodestar-light": "50%",
        "ursa-light": "8px"
      },
      color: {
        selected: {
          "lodestar-light": "currentColor",
          "ursa-light": "transparent"
        },
        rest: {
          "lodestar-light": "transparent",
          "ursa-light": "transparent"
        },
        hover: {
          "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--default"),
          "ursa-light": "transparent"
        },
        active: {
          "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--strong"),
          "ursa-light": "transparent"
        },
        focus: (0, _designTokensReact.color)("color--border--surfaces--focus")
      }
    },
    svg: {
      width: {
        "lodestar-light": "14px",
        "ursa-light": "24px"
      }
    }
  },
  colorInput: {
    label: {
      marginBottom: {
        "lodestar-light": "24px",
        "ursa-light": "20px"
      },
      fontSize: {
        "lodestar-light": "12px",
        "ursa-light": "12px"
      },
      lineHeight: {
        "lodestar-light": "15px",
        "ursa-light": "16px"
      },
      gap: {
        "lodestar-light": "16px",
        "ursa-light": "4px"
      }
    },
    errorColor: (0, _designTokensReact.color)("color--text--error--weak")
  },
  slider: {
    marginBottom: {
      "lodestar-light": "4px",
      "ursa-light": "12px"
    }
  },
  colorPicker: {
    marginBottom: {
      "lodestar-light": "15px",
      "ursa-light": "12px"
    },
    focusColor: (0, _designTokensReact.color)("color--border--surfaces--focus"),
    selectWrapWidth: {
      "lodestar-light": "100px",
      "ursa-light": "84px"
    }
  },
  inputButton: {
    size: {
      "lodestar-light": "small",
      "ursa-light": "xsmall"
    },
    backgroundColor: {
      hover: {
        "lodestar-light": _designTokens.lodestarColors.buttonDefault,
        "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weaker")
      }
    },
    textColor: {
      active: {
        "lodestar-light": _designTokens.lodestarColors.focusDark,
        "ursa-light": (0, _designTokensReact.color)("color--text--primary--stronger")
      }
    }
  },
  inputDot: {
    top: {
      "lodestar-light": "8px",
      "ursa-light": "4px"
    }
  },
  input: {
    padding: {
      left: {
        rest: "36px",
        active: {
          "lodestar-light": "36px",
          "ursa-light": "35px"
        },
        error: {
          "lodestar-light": "36px",
          "ursa-light": "35px"
        }
      },
      right: {
        rest: "64px",
        active: {
          "lodestar-light": "64px",
          "ursa-light": "63px"
        },
        error: {
          "lodestar-light": "64px",
          "ursa-light": "63px"
        }
      }
    }
  }
});
exports.colorPickerTheme = colorPickerTheme;
//# sourceMappingURL=colorPickerTheme.js.map